import type { FeatureProvider } from '..';

import jobStreet from './jobstreet.json';
import seek from './seek.json';

export const applyBranding: FeatureProvider =
  ({ brand }) =>
  (featureInput) => {
    switch (brand) {
      case 'jobstreet':
        return { ...featureInput, ...jobStreet };
      case 'seek':
        return { ...featureInput, ...seek };
      default:
        return featureInput;
    }
  };
